import type { IconData } from '@stacksjs/iconify-core'

export const rectangle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M36 416h440a20.023 20.023 0 0 0 20-20V116a20.023 20.023 0 0 0-20-20H36a20.023 20.023 0 0 0-20 20v280a20.023 20.023 0 0 0 20 20m12-288h416v256H48Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default rectangle
